import { render, staticRenderFns } from "./SamLink.vue?vue&type=template&id=5620bff4&scoped=true&shadow"
import script from "./SamLink.vue?vue&type=script&lang=js&shadow"
export * from "./SamLink.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamLink.vue?vue&type=style&index=0&id=5620bff4&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "5620bff4",
  null
  ,true
)

export default component.exports